var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgClear = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      fill: "var(--color--primary-text)"
    },
    viewBox: "0 0 49.356 49.356",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.254,
    cy: 9.254,
    r: 9.254,
    transform: "translate(15.424 15.426)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.057,11.983a2.057,2.057,0,0,0,2.057-2.057V2.057a2.057,2.057,0,1,0-4.113,0v7.87A2.057,2.057,0,0,0,13.057,11.983Z",
    transform: "translate(11.622)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.057,18.175A2.057,2.057,0,0,0,11,20.232V28.1a2.057,2.057,0,0,0,4.113,0V20.232A2.057,2.057,0,0,0,13.057,18.175Z",
    transform: "translate(11.622 19.202)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.385,12.3a2.094,2.094,0,0,0,2.908,0,2.057,2.057,0,0,0,0-2.908L6.74,3.826a2.06,2.06,0,1,0-2.916,2.91Z",
    transform: "translate(3.405 3.403)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.582,16.676a2.056,2.056,0,1,0-2.908,2.908L22.24,25.15a2.091,2.091,0,0,0,2.908,0,2.057,2.057,0,0,0,0-2.908Z",
    transform: "translate(16.98 16.981)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.981,13.557A2.057,2.057,0,0,0,9.925,11.5H2.057a2.057,2.057,0,0,0,0,4.113H9.925A2.057,2.057,0,0,0,11.981,13.557Z",
    transform: "translate(0 12.15)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1,11.5H20.231a2.057,2.057,0,0,0,0,4.113H28.1a2.057,2.057,0,0,0,0-4.113Z",
    transform: "translate(19.201 12.15)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.381,16.675,3.828,22.241a2.057,2.057,0,0,0,0,2.908,2.091,2.091,0,0,0,2.908,0l5.553-5.565a2.056,2.056,0,1,0-2.908-2.908Z",
    transform: "translate(3.409 16.982)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.13,12.889a2.057,2.057,0,0,0,1.454-.59l5.565-5.565a2.057,2.057,0,1,0-2.908-2.91L16.676,9.391a2.044,2.044,0,0,0,1.454,3.5Z",
    transform: "translate(16.979 3.404)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClear, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/clear.4f14dd30.svg";
export { ForwardRef as ReactComponent };